import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
type ModalType = 'terms' | 'privacy' | null;
export const Footer: React.FC = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const {
    t
  } = useLanguage();
  return <>
      <footer className="bg-dark border-t border-gray-800 py-8" data-id="element-48">
        <div className="container mx-auto px-6 max-w-4xl flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-49">
          <p className="text-gray-500 font-sans text-sm" data-id="element-50">
            © {new Date().getFullYear()} {t('footer.rights')}
          </p>
          <div className="flex items-center space-x-6" data-id="element-51">
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-coral-400 font-sans text-sm transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-52">
              {t('footer.terms')}
            </button>
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-coral-400 font-sans text-sm transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-53">
              {t('footer.privacy')}
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-54">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-55">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-56">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-gray-400 hover:text-dark transition-colors" data-id="element-57">
                <XIcon className="w-5 h-5" data-id="element-58" />
              </button>

              {activeModal === 'terms' && <div data-id="element-59">
                  <h3 className="text-2xl font-bold mb-4 text-dark" data-id="element-60">
                    {t('footer.terms')}
                  </h3>
                  <div className="space-y-4 text-gray-600 font-sans text-sm leading-relaxed" data-id="element-61">
                    <p data-id="element-62">{t('terms.intro')}</p>
                    <p data-id="element-63">
                      <strong className="text-dark" data-id="element-64">
                        {t('terms.1.title')}
                      </strong>{' '}
                      {t('terms.1.desc')}
                    </p>
                    <p data-id="element-65">
                      <strong className="text-dark" data-id="element-66">
                        {t('terms.2.title')}
                      </strong>{' '}
                      {t('terms.2.desc')}
                    </p>
                    <p data-id="element-67">
                      <strong className="text-dark" data-id="element-68">
                        {t('terms.3.title')}
                      </strong>{' '}
                      {t('terms.3.desc')}
                    </p>
                    <p data-id="element-69">
                      <strong className="text-dark" data-id="element-70">
                        {t('terms.4.title')}
                      </strong>{' '}
                      {t('terms.4.desc')}
                    </p>
                    <p data-id="element-71">
                      <strong className="text-dark" data-id="element-72">
                        {t('terms.5.title')}
                      </strong>{' '}
                      {t('terms.5.desc')}
                    </p>
                  </div>
                </div>}

              {activeModal === 'privacy' && <div data-id="element-73">
                  <h3 className="text-2xl font-bold mb-4 text-dark" data-id="element-74">
                    {t('footer.privacy')}
                  </h3>
                  <div className="space-y-4 text-gray-600 font-sans text-sm leading-relaxed" data-id="element-75">
                    <p data-id="element-76">{t('privacy.intro')}</p>
                    <p data-id="element-77">
                      <strong className="text-dark" data-id="element-78">
                        {t('privacy.1.title')}
                      </strong>{' '}
                      {t('privacy.1.desc')}
                    </p>
                    <p data-id="element-79">
                      <strong className="text-dark" data-id="element-80">
                        {t('privacy.2.title')}
                      </strong>{' '}
                      {t('privacy.2.desc')}
                    </p>
                    <p data-id="element-81">
                      <strong className="text-dark" data-id="element-82">
                        {t('privacy.3.title')}
                      </strong>{' '}
                      {t('privacy.3.desc')}
                    </p>
                    <p data-id="element-83">
                      <strong className="text-dark" data-id="element-84">
                        {t('privacy.4.title')}
                      </strong>{' '}
                      {t('privacy.4.desc')}
                    </p>
                    <p data-id="element-85">
                      <strong className="text-dark" data-id="element-86">
                        {t('privacy.5.title')}
                      </strong>{' '}
                      {t('privacy.5.desc')}
                    </p>
                  </div>
                </div>}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};